// YERELDE CANLI ÖNİZLEME: açık kalan önizleme sayfası, yeni bir derleme
// yayınlandığında kendiliğinden tazelenir — kullanıcı F5'e basmak zorunda kalmaz.
// YALNIZCA localhost'ta çalışır; canlı/VPS ortamında hiçbir etkisi yoktur.
(function devLiveReload() {
  if (typeof window === "undefined") return;
  const host = window.location.hostname;
  if (host !== "localhost" && host !== "127.0.0.1") return;

  let current = null;
  setInterval(async () => {
    try {
      const res = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
      if (!res.ok) return;
      const data = await res.json();
      if (!data || !data.v) return;
      if (current !== null && data.v !== current) {
        window.location.reload();
        return;
      }
      current = data.v;
    } catch {
      /* sunucu henüz hazırsa sessizce bekle */
    }
  }, 8000);
})();
